import {Observable, of} from 'rxjs';

export const undefined$: () => Observable<void> = () => of(undefined);
